import React from 'react';
import { POSTED } from '../../../../add-ons/consts.js';
import { messages } from '../../locale/';
import styles from '../../styles-module.css';

const StatusCell = ({ intl, status }) => {
  const isPosted = status === POSTED;
  const containerClass = [styles.circle, isPosted ? styles.posted : styles.draft].join(" ");
  const textContainerClass = [styles.statusText, isPosted ? styles.postedText : styles.draftText].join(" ");

  return (
    <div className={styles.statusCell}>
      <div className={containerClass} />
      <div className={textContainerClass}>
        {
          isPosted
            ? intl.formatMessage(messages.statusCellLive) 
            : intl.formatMessage(messages.statusCellDraft)
        }
      </div>
    </div>
  );
};

export default StatusCell;
